import { api } from "@api/api";
import { UsageAnalytics } from "@modules/usages/types";

export async function getUsageAnalyticsService(
  filters?: Record<string, string>
): Promise<UsageAnalytics> {
  const { data } = await api.get<UsageAnalytics>(`v1/usage_admin/analytics/`, {
    params: filters,
  });
  return data;
}
